import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import * as Sentry from '@sentry/react';
import { AuthProvider } from '@/hooks/useAuth';
import { ThemeProvider } from '@/components/ThemeProvider';
import { ToastProvider, ConfirmProvider } from '@mustauto/ui/web';
import { router } from './router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

function FallbackError() {
  return (
    <div style={{ padding: 32, textAlign: 'center' }}>
      <h2>Algo deu errado</h2>
      <p>Ocorreu um erro inesperado. Tente recarregar a página.</p>
      <button onClick={() => window.location.reload()}>Recarregar</button>
    </div>
  );
}

export function App() {
  return (
    <Sentry.ErrorBoundary fallback={FallbackError}>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <ToastProvider>
              <ConfirmProvider>
                <RouterProvider router={router} />
              </ConfirmProvider>
            </ToastProvider>
          </AuthProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  );
}
